var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFashion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 32,
    viewBox: "0 0 41 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0C18.6435 0 16.863 0.737498 15.5503 2.05025C14.2375 3.36301 13.5 5.14348 13.5 7H17.5C17.5 6.20435 17.8161 5.44129 18.3787 4.87868C18.9413 4.31607 19.7044 4 20.5 4C21.2956 4 22.0587 4.31607 22.6213 4.87868C23.1839 5.44129 23.5 6.20435 23.5 7C23.5 7.79565 23.1839 8.55871 22.6213 9.12132C22.0587 9.68393 21.2956 10 20.5 10C19.4 10 18.5 10.9 18.5 12V15.5L1.3 28.4C0.964188 28.6519 0.716133 29.003 0.590973 29.4037C0.465813 29.8043 0.469892 30.2342 0.602633 30.6325C0.735375 31.0307 0.990048 31.377 1.33058 31.6225C1.67111 31.8679 2.08024 32 2.5 32H38.5C38.9198 32 39.3289 31.8679 39.6694 31.6225C40.01 31.377 40.2646 31.0307 40.3974 30.6325C40.5301 30.2342 40.5342 29.8043 40.409 29.4037C40.2839 29.003 40.0358 28.6519 39.7 28.4L22.5 15.5V13.7C23.9433 13.2697 25.2093 12.3854 26.11 11.1784C27.0108 9.97138 27.4982 8.50606 27.5 7C27.5 5.14348 26.7625 3.36301 25.4497 2.05025C24.137 0.737498 22.3565 0 20.5 0ZM20.5 19L32.5 28H8.5L20.5 19Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFashion);
export default __webpack_public_path__ + "static/media/fashion.f39adafae636d1f4e3345284bde75721.svg";
export { ForwardRef as ReactComponent };